var getParameterByName = require('../lib/getParameterByName.js');
var Debouncer = require('../lib/Debouncer.js');
var FontFaceObserver = require('fontfaceobserver');

// NOTE: This was copied from Squeegee Squad, so some of the variable names don't make sense.
// Each level represents one tab

function init() {
	var productTabs = document.getElementsByClassName('productTabs');
	if (!productTabs.length) {
		return;
	}

	/** The width at which the component switches
	 * from tabbed view to accordion.
	 */
	var breakpoint = 860;

	var activeClass = 'active';
	var tabTargetEl = productTabs[0].getElementsByClassName('tabControl');
	var accordionTargetEl = productTabs[0].getElementsByClassName('productTab__accordionControl');
	var courseEl = productTabs[0].getElementsByClassName('productTab');
	var defaultLevel = [tabTargetEl[0], courseEl[0], accordionTargetEl[0]];

	var courseFrame = productTabs[0].getElementsByClassName('productTabs__contents')[0];

	/** A class for levels */
	function Level(config) {
		this.id = config.id;
		this.name = config.name;
		this.tabTargetEl = config.tabTargetEl;
		this.accordionTargetEl = config.accordionTargetEl;
		this.courseEl = config.courseEl;

		/**
		 * Activates the elements passed in
		 * @param {Node[]} elArr
		 */
		this.addActiveClasses = function(elArr) {
			if (!elArr.length)
				return;

			for (var i = 0; i < elArr.length; i++) {
				elArr[i].classList.add(activeClass);
			}
		}

		this.removeActiveClasses = function(elArr) {
			if (!elArr.length)
				return;

			for (var i = 0; i < elArr.length; i++) {
				elArr[i].classList.remove(activeClass);
			}
		}

		this.activateSimpleClick = function() {
			var currentSelected = [this.tabTargetEl, this.courseEl];
			if (this.courseEl.classList.contains(activeClass)) {
				this.removeActiveClasses(currentSelected);
			} else {
				this.addActiveClasses(currentSelected);
			}

			this.adjustFrame();
		}

		this.activateTabClick = function(force) {
			// Don't run if this level is active
			if (this.courseEl.classList.contains(activeClass) && !force)
				return;

			// Remove existing active
			var currentActive = productTabs[0].getElementsByClassName(activeClass);
			removeCourseActiveClass(currentActive);

			//Activate elements
			var activeLevel = [this.tabTargetEl, this.courseEl];
			this.addActiveClasses(activeLevel);

			// Update the URL and page title
			history.replaceState({}, this.name, window.location.href.split('?')[0] + '?tab=' + this.id);
			// document.title = this.name;

			this.adjustFrame();
		}

		this.adjustFrame = function() {
			// If desktop width, adjust height of frame
			if (window.innerWidth > breakpoint) {
				var font = new FontFaceObserver('Montserrat');
				var that = this;
				
				font.load().then(function () {
					courseFrame.style.height = that.courseEl.getBoundingClientRect().height + 'px';
				}, function () {
					courseFrame.style.height = that.courseEl.getBoundingClientRect().height + 'px';
				});
			} else {
				courseFrame.style.removeProperty('height');
			}
		}
	}

	/** Builds levels for script */
	function levelFactory() {
		for (var i = 0; i < tabTargetEl.length; i++) {
			levels.push(
				new Level({
					id: encodeURIComponent(
						tabTargetEl[i]
							.innerText.replace(/\s+/g, '-')
							.toLowerCase()
						),
					name: tabTargetEl[i].innerText.replace(/\s+/g, ' '),
					tabTargetEl: tabTargetEl[i],
					accordionTargetEl: accordionTargetEl[i],
					courseEl: courseEl[i],
					activeClass: activeClass
				})
			)
		}
	}

	/** Tests if URL param set and activates relevant tab */
	function activateInitial() {
		// Remove other active classes
		removeCourseActiveClass(productTabs[0].getElementsByClassName(activeClass));

		var activeTab = getParameterByName('level');
		if (activeTab) {
			for (var i = 0; i < levels.length; i++) {
				if (activeTab === levels[i].id) {
					// Add relevant active classes
					levels[i].activateSimpleClick(true);
					break;
				}

				// NOTE: Should only run if the param
				// does not contain a valid ID
				if (i === levels.length - 1) {
					levels[0].activateSimpleClick(true);
				}
			}
		} else {
			levels[0].activateSimpleClick(true);
		}
	}

	var levels = [];
	levelFactory();


	/**
	 * Recursively loops through active nodes and removes active class
	 * @param {HTMLCollection} collection
	 */
	function removeCourseActiveClass(collection) {
		if (!collection.length)
			return;

		collection[0].classList.remove(activeClass);
		removeCourseActiveClass(collection);
	}

	function handleTabClick(index) {
		return function() {
			levels[index].activateTabClick();
		}
	}
	function handleSimpleClick(index) {
		return function() {
			levels[index].activateSimpleClick();
		}
	}

	// Set click handlers
	for (var i = 0; i < tabTargetEl.length; i++) {
		var myHandleClick = handleTabClick(i);
		tabTargetEl[i].addEventListener('click', myHandleClick);
	}

	for (var i = 0; i < accordionTargetEl.length; i++) {
		var myHandleClick = handleSimpleClick(i);
		accordionTargetEl[i].addEventListener('click', myHandleClick);
	}

	function resizeHandler() {
		var activeIndices = [];
		for (var i = 0; i < courseEl.length; i++) {
			if (courseEl[i].classList.contains(activeClass)) {
				activeIndices.push(i);
			}
		}

		if (!activeIndices.length) {
			activeIndices.push(0);
		}

		if (window.innerWidth > breakpoint) {
			levels[activeIndices[0]].activateTabClick(true);
		} else {
			levels[activeIndices[0]].adjustFrame();
		}
	}

	window.addEventListener('resize', (new Debouncer(resizeHandler).run));

	activateInitial();
	window.onpopstate = function() {
		activateInitial();
	}

}

module.exports = {
	init: init
};